var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 5.3125H4.8125C4.05311 5.3125 3.4375 5.92811 3.4375 6.6875V12.1875C3.4375 12.9469 4.05311 13.5625 4.8125 13.5625H17.1875C17.9469 13.5625 18.5625 12.9469 18.5625 12.1875V6.6875C18.5625 5.92811 17.9469 5.3125 17.1875 5.3125Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 13.5625H4.8125C4.05311 13.5625 3.4375 14.1781 3.4375 14.9375V17.6875C3.4375 18.4469 4.05311 19.0625 4.8125 19.0625H17.1875C17.9469 19.0625 18.5625 18.4469 18.5625 17.6875V14.9375C18.5625 14.1781 17.9469 13.5625 17.1875 13.5625Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1875 5.3125H4.8125C4.44814 5.31148 4.099 5.16629 3.84136 4.90864C3.58371 4.651 3.43852 4.30186 3.4375 3.9375C3.43852 3.57314 3.58371 3.224 3.84136 2.96636C4.099 2.70871 4.44814 2.56352 4.8125 2.5625H17.1875C17.5519 2.56352 17.901 2.70871 18.1586 2.96636C18.4163 3.224 18.5615 3.57314 18.5625 3.9375C18.5615 4.30186 18.4163 4.651 18.1586 4.90864C17.901 5.16629 17.5519 5.31148 17.1875 5.3125ZM6.1875 19.0625V20.0078C6.1875 20.1218 6.14223 20.2311 6.06165 20.3116C5.98107 20.3922 5.87177 20.4375 5.75781 20.4375H4.55469C4.44073 20.4375 4.33143 20.3922 4.25085 20.3116C4.17027 20.2311 4.125 20.1218 4.125 20.0078V19.0625H6.1875ZM17.875 19.0625V20.0078C17.875 20.1218 17.8297 20.2311 17.7491 20.3116C17.6686 20.3922 17.5593 20.4375 17.4453 20.4375H16.2422C16.1282 20.4375 16.0189 20.3922 15.9384 20.3116C15.8578 20.2311 15.8125 20.1218 15.8125 20.0078V19.0625H17.875Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 17C16.1922 17 16.5 16.6922 16.5 16.3125C16.5 15.9328 16.1922 15.625 15.8125 15.625C15.4328 15.625 15.125 15.9328 15.125 16.3125C15.125 16.6922 15.4328 17 15.8125 17Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1875 17C6.5672 17 6.875 16.6922 6.875 16.3125C6.875 15.9328 6.5672 15.625 6.1875 15.625C5.8078 15.625 5.5 15.9328 5.5 16.3125C5.5 16.6922 5.8078 17 6.1875 17Z",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.3125V13.5625M3.4375 3.9375V16.3125M18.5625 3.9375V16.3125",
    stroke: "#435869",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCar);
export default __webpack_public_path__ + "static/media/ic-car.af02724e4f893ee9a33a90858326b77c.svg";
export { ForwardRef as ReactComponent };